import React, { useEffect, useState } from "react";
import MainContainer from "../../../container/MainContainer";
import Arrow from "../../../images/Arrow-Right.svg";
import { Link } from "react-router-dom";
import download from "../../../images/DownloadCsv.svg";
import TransactionTable from "./TransactionTable";
import { useLazyQuery ,useQuery} from "@apollo/react-hooks";
import { hasuraClient } from "../../../apolloClient";
import { GET_LAST_TRANSACTION } from "../../../query/getLastTrans";
import { VIEW_PROFILE } from "../../../query/ViewProfile";
import moment from "moment";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const TransactionDetails = () => {
  const [data, setData] = React.useState([]);
  const [dataSet, setDataSet] = useState([]);
  const [pageCount, setPageCount] = React.useState(0);

  const { data:userDetails } = useQuery(VIEW_PROFILE, {
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });
  const [
    getTransData,
    { data: transData, loading: transLoading, error: transError },
  ] = useLazyQuery(GET_LAST_TRANSACTION, {
    client: hasuraClient,
    fetchPolicy: "cache-and-network",
  });

  useEffect(() => {
    getTransData({
      variables: {
        search_text: "%%",
        order_by: { created_at: "desc" },
        profile_id: localStorage.getItem("profile_id"),
      },
    });
  }, []);
  useEffect(() => {
    let arr = [];
    if (transData && transData?.business_council_last_transactions?.length) {
      for (
        let i = 0;
        i < transData?.business_council_last_transactions?.length;
        i++
      ) {
        arr.push({
          full_name:
            transData?.business_council_last_transactions[i]?.full_name,
          event_name:
            transData?.business_council_last_transactions[i]?.event_name,
          quantity: transData?.business_council_last_transactions[i]?.quantity,
          price:
            transData?.business_council_last_transactions[i]?.purchased_price,
          type: transData?.business_council_last_transactions[i]?.option_name,
          created_at: moment(
            transData?.business_council_last_transactions[i]?.created_at
          ).format("DD.MM.YYYY"),
        });
      }
    }
    setPageCount(arr.length);
    setData(arr);
    setDataSet(arr);
  }, [transData]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "full_name",
        className: "com-name",
      },
      {
        Header: "Event",
        accessor: "event_name",
        className: "com-loc",
      },
      {
        Header: "QUANTITY",
        accessor: "quantity",
        className: "com-members",
      },
      {
        Header: "PAYMENT",
        accessor: "price",
        className: "com-events",
      },
      {
        Header: "TYPE",
        accessor: "type",
        className: "com-date",
      },
      {
        Header: "DATE Purchsed",
        accessor: "created_at",
        className: "com-date",
      },
    ],
    []
  );

  return (
    <MainContainer>
      <section className="settings-section comunites-row">
        <div className="title">
          <div className="back-button">
            <Link to="/dashboard">
              <img src={Arrow} alt="arrow right" />
            </Link>
            <h2>Transactions</h2>
          </div>
          {dataSet.length > 0 ? (
            <ExcelFile
              element={
                <img
                  src={download}
                  alt="download icon"
                  style={{ cursor: "pointer" }}
                />
              }
            >
              <ExcelSheet data={dataSet} name="Transactions">
                <ExcelColumn label="NAME" value="full_name" />
                <ExcelColumn label="EVENT" value="event_name" />
                <ExcelColumn label="QUANTITY" value="quantity" />
                <ExcelColumn label="PAYMENT" value="price" />
                <ExcelColumn label="TYPE" value="type" />
                <ExcelColumn label="DATE PURCHSED" value="created_at" />
              </ExcelSheet>
            </ExcelFile>
          ) : (
            <img
              src={download}
              alt="download icon"
              style={{ cursor: "pointer" }}
            />
          )}
          {/* <Dropdown>
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      <img src={download} alt="download icon" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">
                        <span>Export as .CSV</span>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown> */}
        </div>
        <div className="comunites-table">
          <div className="table-box">
            <TransactionTable
              columns={columns}
              setPageCount={setPageCount}
              pageCount={pageCount}
              data={data}
              getTransData={getTransData}
              transLoading={transLoading}
              transError={transError}
            />
          </div>
        </div>
      </section>
    </MainContainer>
  );
};

export default TransactionDetails;
